import React, { useState } from 'react';
import { TrendingUp, AlertTriangle, Package, DollarSign, Calendar, BarChart3, GitCompare, MessageSquare } from 'lucide-react';
import { colors } from '../../../constants/theme';
import WeeklyPlanGrid from './WeeklyPlanGrid';
import ScenarioCompare from './ScenarioCompare';
import KPIDashboard from './KPIDashboard';
import MDDialogFlow from './MDDialogFlow';

const MDAgent: React.FC = () => {
  return (
    <div className="h-full overflow-y-auto">
      <div className="p-3">
        {/* コンパクトヘッダー */}
        <div className="mb-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <h2 className="text-lg font-bold" style={{ color: colors.text.primary }}>
                52週MDエージェント
              </h2>
              <p className="text-sm" style={{ color: colors.text.secondary }}>
                年間の商品・価格・販促計画を自動最適化
              </p>
            </div>
            <div className="flex gap-2">
              <button className="px-3 py-1 text-xs border rounded-lg hover:bg-gray-50" style={{ borderColor: colors.ui.border }}>
                計画生成
              </button>
              <button className="px-3 py-1 text-xs bg-blue-500 text-white rounded-lg hover:bg-blue-600">
                価格最適化
              </button>
            </div>
          </div>
        </div>

        {/* コンパクトKPIサマリー */}
        <div className="grid grid-cols-4 gap-2 mb-3">
          <KPICard
            title="予測粗利率"
            value="26.3%"
            change="+1.3%"
            icon={<DollarSign />}
            trend="up"
          />
          <KPICard
            title="在庫回転率"
            value="12.5回"
            change="+0.8回"
            icon={<Package />}
            trend="up"
          />
          <KPICard
            title="機会ロス"
            value="-18.0%"
            change="-3.2%"
            icon={<AlertTriangle />}
            trend="down"
          />
          <KPICard
            title="売上予測"
            value="¥158.5M"
            change="+8.5%"
            icon={<TrendingUp />}
            trend="up"
          />
        </div>

        {/* 残りのコンポーネント表示 */}
        <div className="space-y-3">
          {/* 52週MD計画 - 週次仕入れ最適化 */}
          <div className="bg-white rounded-lg shadow-sm">
            <MDDialogFlow />
          </div>

          {/* シナリオ比較分析 */}
          <div className="bg-white rounded-lg shadow-sm">
            <ScenarioCompare />
          </div>
        </div>
      </div>
    </div>
  );
};

// KPIカードコンポーネント
interface KPICardProps {
  title: string;
  value: string;
  change: string;
  icon: React.ReactNode;
  trend: 'up' | 'down' | 'neutral';
}

const KPICard: React.FC<KPICardProps> = ({ title, value, change, icon, trend }) => {
  const getTrendColor = () => {
    switch(trend) {
      case 'up':
        return colors.ui.success;
      case 'down':
        return colors.accent.red;
      default:
        return colors.text.secondary;
    }
  };

  return (
    <div 
      className="p-2 rounded-lg border"
      style={{ borderColor: colors.ui.border }}
    >
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs" style={{ color: colors.text.secondary }}>
          {title}
        </span>
        {React.isValidElement(icon) ? React.cloneElement(icon, { size: 14, style: { color: colors.text.secondary } }) : icon}
      </div>
      <div className="text-lg font-bold mb-1" style={{ color: colors.text.primary }}>
        {value}
      </div>
      <div className="text-xs" style={{ color: getTrendColor() }}>
        {change}
      </div>
    </div>
  );
};

export default MDAgent;